import { GameObjects, Scene } from "phaser";

export class Text extends GameObjects.Text {
  constructor(scene: Scene, x: number, y: number, text: string) {
    super(scene, x, y, text, {
      fontFamily: "Courier",
      color: "#fff",
      stroke: "#000",
      strokeThickness: 3,
      align: "center",
    });
    scene.add.existing(this);
  }
}
